import fetch from "./fetch";

/**
 * 新建卷
 * @param bookId 书籍ID
 * @param data    新建卷数据
 */
export function addVolume_api({bookId, data}) {
	return fetch({
		url: `/book/${bookId}/volume`,
		method: 'post',
		data
	})
}

/**
 *    修改卷信息
 * @param bookId 作品ID
 * @param id    卷ID
 * @param data    修改卷数据
 */
export function updateVolume_api({bookId, id, data}) {
	return fetch({
		url: `/book/${bookId}/volume/${id}`,
		method: 'put',
		data
	})
}

/**
 * 删除卷
 * @param bookId 作品ID
 * @param id    卷ID
 */
export function deleteVolume_api({bookId, id}) {
	return fetch({
		url: `/book/${bookId}/volume/${id}`,
		method: 'delete'
	})
}

/**
 * 获取指定书的所有卷
 * @param bookId  作品ID
 */
export function getVolumeList_api(bookId) {
	return fetch({
		url: `/book/${bookId}/volumes`,
		method: 'get'
	})
}

/**
 * 获取指定ID卷的详细信息
 * @param id 卷id
 */
export function getVolumeDetail_api(id) {
	return fetch({
		url: `/volume/${id}`,
		method: 'get'
	})
}



// WEBPACK FOOTER //
// ./src/api/volume.js